<template>
  <v-container fluid class="service-detail-height">
    <v-row>
      <v-col cols="6" class="py-0 pl-0">
        <v-card flat class="remove-border-radius mb-4">
          <v-card-title class="headline grey lighten-4 py-0">
            <span class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase">Basic
              Information</span>
          </v-card-title>
          <v-card-text class="font-size-16 pre-wrap px-0 py-0">
            <table class="width-100">
              <tr>
                <td class="font-size-18 font-weight-500 py-1" width="150">
                  Specification
                </td>
                <td class="font-size-18 py-1">
                  <span v-if="detail && detail.specification">
                    {{ detail.specification }}
                  </span>
                  <em v-else class="text-muted"> no specification </em>
                </td>
              </tr>
              <tr>
                <td class="font-size-18 font-weight-500 py-1" width="150">
                  Tags
                </td>
                <td class="font-size-18 py-1">
                  <template v-if="detail?.tags?.length > 0">
                    <span v-if="detail && detail.tags">
                      <v-chip v-for="(row, index) in detail.tags" :key="index" class="mr-2" text-color="white"
                        :color="row.color" small>{{ row.text }}</v-chip>
                    </span>
                  </template>
                  <em v-else class="text-muted"> no Tags</em>
                </td>
              </tr>
              <tr v-if="false">
                <td class="font-size-18 font-weight-500 py-1" valign="top">
                  Free Slot
                </td>
                <td class="font-size-18 py-1">
                  <span v-if="detail && detail.slot_free_after_payfailed">{{ detail.slot_free_after_payfailed }}
                    Minutes</span>
                  <em v-else class="text-muted"> no free slot </em>
                </td>
              </tr>
              <tr>
                <td class="font-size-18 font-weight-500 py-1" valign="top">
                  Advanced Day Booking
                </td>
                <td class="font-size-18 py-1">
                  <span v-if="detail && detail.booking_advance_days">{{
                    detail.booking_advance_days
                  }} Days</span>
                  <em v-else class="text-muted"> no advanced booking </em>
                </td>
              </tr>
              <template v-if="detail.is_recurring == 1">
                <tr v-if="false">
                  <td class="font-size-18 font-weight-500 py-1" valign="top">
                    Special Dates Of
                  </td>
                  <td class="font-size-18 py-1">
                    <span v-if="detail && detail.dates_off">
                      <li v-for="(row, index) in detail.dates_off" :key="index">
                        {{ formatDate(row) }}
                      </li>
                    </span>
                    <em v-else class="text-muted"> no special dates off </em>
                  </td>
                </tr>
                <tr v-if="false">
                  <td class="font-size-18 font-weight-500 py-1" valign="top">
                    Payment Before Job
                  </td>
                  <td class="font-size-18 py-1">

                    <v-chip small :color="detail?.payment_before_job == 1 ? 'green' : 'red'" variant="flat"
                      text-color="white">
                      {{ detail?.payment_before_job == 1 ? 'Yes' : 'No' }}
                    </v-chip>

                  </td>
                </tr>
                <tr v-if="detail.payment_before_job == 1 && false">
                  <td class="font-size-18 font-weight-500 py-1" valign="top">
                    Payment Before Job
                  </td>
                  <td class="font-size-18 py-1">
                    <v-chip v-if="detail && detail.payment_before_job_days" small
                      :color="detail.payment_before_job == 1 ? 'blue' : 'red'" variant="flat" text-color="white">
                      {{ detail?.payment_before_job_days }} Days
                    </v-chip>

                  </td>
                </tr>
                <tr>
                  <td class="font-size-18 font-weight-500 py-1" valign="top">
                    Maximum No. Of Jobs
                  </td>
                  <td class="font-size-18 py-1">
                    <span v-if="detail && detail.recurring_occurrence_limit">{{
                      detail.recurring_occurrence_limit
                    }}</span>
                    <em v-else class="text-muted"> no booking per order </em>
                  </td>
                </tr>
                <tr v-if="false">
                  <td class="font-size-18 font-weight-500 py-1" valign="top">
                    Off Day Service Rules
                  </td>
                  <td class="font-size-18 py-1">
                    <span v-if="detail && detail.off_day_service_rules">{{
                      detail.off_day_service_rules
                    }}</span>
                    <em v-else class="text-muted"> no off day service rules </em>
                  </td>
                </tr>
              </template>
              <tr>
                <td class="font-size-18 font-weight-500 py-1" valign="top">
                  Cleaner Required
                </td>
                <td class="font-size-18 py-1">
                  <v-chip small :color="detail?.engineer_required == 1 ? 'green' : 'red'" variant="flat"
                    text-color="white">
                    {{ detail?.engineer_required == 1 ? 'Yes' : 'No' }}
                  </v-chip>
                </td>
              </tr>
              <tr v-if="detail.engineer_required == 1 && detail.isHouseTypeAvailable != 1">
                <td class="font-size-18 font-weight-500 py-1" valign="top">
                  Minimum Worker
                </td>
                <td class="font-size-18 py-1">
                  <span v-if="detail && detail.min_team">{{
                    detail.min_team
                  }}</span>
                  <em v-else class="text-muted"> no min team </em>
                </td>
              </tr>

              <tr v-if="detail.engineer_required == 1 && detail.isHouseTypeAvailable != 1">
                <td class="font-size-18 font-weight-500 py-1" valign="top">
                  Maximum Worker
                </td>
                <td class="font-size-18 py-1">
                  <span v-if="detail && detail.max_team">{{
                    detail.max_team
                  }}</span>
                  <em v-else class="text-muted"> no max team </em>
                </td>
              </tr>
              <tr>
                <td class="font-size-18 font-weight-500 py-1" valign="top">
                  Zone
                </td>
                <td class="font-size-18 py-1">
                  <span class="text-capitalize" v-if="detail && detail.zone_list && detail.zone_list.length > 0">{{
                    getZoneName(detail.zone_list) }}</span>
                  <em v-else class="text-muted"> no zone </em>
                </td>
              </tr>
              <tr>
                <td class="font-size-18 font-weight-500 py-1" valign="top">
                  Payment Mode
                </td>
                <td class="font-size-18 py-1">
                  <span class="text-capitalize"
                    v-if="detail && detail.payment_mode && detail.payment_mode.length > 0">{{
                      (detail.payment_mode).join(", ") }}</span>
                  <em v-else class="text-muted"> no payment mode </em>
                </td>
              </tr>
              <tr>
                <td class="font-size-18 font-weight-500 py-1" valign="top">
                  Service form Required
                </td>
                <td class="font-size-18 py-1">
                  <span class="text-capitalize" v-if="detail && detail.is_service_form && detail.is_service_form">
                    <v-chip v-if="detail && detail.is_service_form == 1" class="mr-2" text-color="white" color="green"
                      small>Yes</v-chip>
                    <v-chip v-else class="mr-2" text-color="white" color="red" small>No</v-chip>
                  </span>
                  <em v-else class="text-muted"> no service form </em>

                </td>
              </tr>
              <tr v-if="false">
                <td class="font-size-18 font-weight-500 py-1" valign="top">
                  Max Performed Jobs
                </td>
                <td class="font-size-18 py-1">
                  <span v-if="detail && detail.daily_service_limit">{{
                    detail.daily_service_limit
                  }}</span>
                  <em v-else class="text-muted"> no service limit daily</em>
                </td>
              </tr>
              <tr v-if="false">
                <td class="font-size-18 font-weight-500 py-1" valign="top">
                  Notify
                </td>
                <td class="font-size-18 py-1">
                  <span v-if="detail && detail.notify">
                    <b> Admin:</b> {{ detail?.notify?.admin }} Hours,
                    <b>
                      Sales:
                    </b> {{ detail?.notify?.sales }} Hours,
                    <b>
                      Customer:
                    </b> {{ detail?.notify?.customer }} Hours
                  </span>
                  <em v-else class="text-muted"> no notify</em>
                </td>
              </tr>
              <!-- <tr>
                <td class="font-size-18 font-weight-500 py-1" valign="top">
                  Description
                </td>
                <td class="font-size-18 py-1">
                  <span v-if="detail && detail.description" v-html="detail.description"></span>
                  <em v-else class="text-muted"> no description </em>
                </td>
              </tr>
              <tr>
                <td class="font-size-18 font-weight-500 py-1" valign="top">
                  Terms and Condition
                </td>
                <td class="font-size-18 py-1">
                  <span v-if="detail && detail.terms_and_condition" v-html="detail.terms_and_condition"></span>
                  <em v-else class="text-muted"> no terms and condition </em>
                </td>
              </tr> -->
            </table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" class="py-0 pl-0">
        <v-card flat class="remove-border-radius mb-4">
          <v-card-title class="headline grey lighten-4 py-0">
            <span
              class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase">Description</span>
          </v-card-title>
          <v-card-text class="font-size-16 pre-wrap px-0 py-0">
            <table class="width-100">
              <tr>
                <td class="font-size-18 py-1">
                  <span v-if="detail && detail.description" v-html="detail.description"></span>
                  <em v-else class="text-muted"> no description </em>
                </td>
              </tr>
            </table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" class="pb-0 pl-0 pt-0" v-if="detail?.selected_add_on_list?.house_type">
        <v-card flat class="custom-grey-border remove-border-radius">
          <v-card-title class="headline grey lighten-4 py-0">
            <span class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase"> House Type
              Details
            </span>
          </v-card-title>
          <v-card-text class="p-6 font-size-16">
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="simple-table-th px-2">#</th>
                    <th class="simple-table-th px-2">House Type</th>
                    <th class="simple-table-th px-2">Size</th>
                    <!-- <th class="simple-table-th px-2">Slots</th> -->
                  </tr>
                </thead>
                <tbody>
                  <template v-if="detail?.selected_add_on_list?.length > 0">
                    <tr v-for="(row, index) in detail.selected_add_on_list" :key="index" :class="{
                      'custom-border-top': index == 0,
                      'orange_lighten-5': index % 2 == 0,
                    }">
                      <td class="simple-table-td">{{ index + 1 }}</td>

                      <td class="simple-table-td text-capitalize">
                        {{ row.house_type }}
                      </td>
                      <td class="simple-table-td text-capitalize">
                        {{ row.size }}
                      </td>
                      <!-- <td class="simple-table-td text-capitalize">
                        {{ row.slots }}
                      </td> -->
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" class="pb-0 pl-0 pt-0" v-if="show_skills == 1 && false">
        <v-card flat class="custom-grey-border remove-border-radius mt-4">
          <v-card-title class="headline grey lighten-4 py-0">
            <span class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase">Skills , Licence
              &
              Certs Information</span>
          </v-card-title>
          <v-card-text class="p-6 font-size-16">
            <v-simple-table fixed-header height="67vh">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="simple-table-th px-2">#</th>
                    <th class="simple-table-th px-2">Color</th>
                    <th class="simple-table-th px-2">Name</th>
                    <th class="simple-table-th px-2">Type</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="detail?.certificates?.length > 0">
                    <tr v-for="(row, index) in detail.certificates" :key="index" :class="{
                      'custom-border-top': index == 0,
                      'orange_lighten-5': index % 2 == 0,
                    }">
                      <td class="simple-table-td">{{ index + 1 }}</td>
                      <td class="simple-table-td">
                        <v-chip small :color="row.color" variant="flat"></v-chip>
                      </td>
                      <td class="simple-table-td text-capitalize">
                        {{ row.name }}
                      </td>
                      <td class="simple-table-td text-capitalize">
                        {{ row.type }}
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <template v-if="pageLoading">
                      <tr v-for="row in 5" :key="row">
                        <td>
                          <v-skeleton-loader type="text" class="custom-skeleton table-rows-text"></v-skeleton-loader>
                        </td>
                        <td>
                          <v-skeleton-loader type="text" class="custom-skeleton table-rows-text"></v-skeleton-loader>
                        </td>
                        <td>
                          <v-skeleton-loader type="text" class="custom-skeleton table-rows-text"></v-skeleton-loader>
                        </td>
                        <td>
                          <v-skeleton-loader type="text" class="custom-skeleton table-rows-text"></v-skeleton-loader>
                        </td>
                      </tr>
                    </template>
                    <tr v-else-if="!pageLoading">
                      <td colspan="4">
                        <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
                          <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
                          Uhh... There are no row at the moment.
                        </p>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <CustomFormDetail class="px-0" module="service" :module-id="detail.id" />
    </v-row>
  </v-container>
</template>

<script>
import CustomFormDetail from "@/view/pages/custom-field-v2/CustomFormDetail.vue";
import moment from "moment-timezone";
import { GET } from "@/core/services/store/request.module";
import { map } from "lodash";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  data() {
    return {
      product: 0,
      panel: 0,
      panelImage: 0,
      pageLoading: false,
      dataLoading: true,
      summary: "this_week",
      show_skills: 0,
      summaryFilter: [
        { text: "This Week", value: "this_week" },
        { text: "Previous Week", value: "previous_week" },
        { text: "This Month", value: "this_month" },
        { text: "Previous Month", value: "previous_month" },
        /*{ text: "This Quarter", value: "this_quarter" },
        { text: "Previous Quarter", value: "previous_quarter" },*/
        { text: "This Year", value: "this_year" },
        { text: "Previous Year", value: "previous_year" },
      ],
      certificates: [],
    };
  },
  props: {
    detail: {
      type: Object,
      required: true,
      default: () => {
        return new Object();
      },
    },
  },
  watch: {
    detail: {
      deep: true,
      immediate: true,
      handler(param) {
        this.product = this.lodash.toSafeInteger(param.id);
      },
    },
  },
  components: {
    CustomFormDetail,
  },
  methods: {
    getZoneName(zoneArr) {
      let zoneNameArr = map(zoneArr, (row) => row.zone && row.zone.name);
      return zoneNameArr.join(", ");
    },
    getServiceSetting() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "setting/service" })
        .then(({ data }) => {
          _this.show_skills = data.service_skills_allow;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    formatDate(date) {
      if (!date) return null;
      return moment(date).format("d/M/y");
    },
  },
  mounted() {
    /* this.getSummary(); */
    this.getServiceSetting();
  },
};
</script>
<style scoped>
.v-expansion-panel::before {
  box-shadow: none;
}
</style>
